export default __webpack_public_path__ + "static/media/1@3x.0153aa26.png";